import React from "react";
import { Empty, Skeleton, Table, Tooltip } from "antd";

// `moment/locale/mn` импортолдог байсныг хассан: тэр нь аппын глобал moment
// хэлийг чимээгүй сольдог байсан ба энд зөвхөн тоон формат ашигладаг тул
// хэрэггүй (кодын санд хэл хамааралтай формат хаана ч алга).
import moment from "moment";

import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

/** Захиалгын кодын эхний үсэг → дэлгэрэнгүй хуудасны зам */
const ORDER_ROUTE_BY_PREFIX = {
  D: "deliveries",
  R: "returns",
  F: "picks",
};

const NOTE_ICON_COLOR = "#FFAA00";

const columns = [
  {
    key: "order",
    render: (text, { code = "", note, email }) => {
      const route = ORDER_ROUTE_BY_PREFIX[code.substring(0, 1)];

      return (
        <div className="pending_order_row">
          <div className="pending_order_icon">
            <AlertCircle size={18} style={{ color: NOTE_ICON_COLOR }} />
          </div>
          <div className="pending_order_texts">
            {route ? (
              <Link className="pending_order_code" to={`/merchant/order/${route}/${code}`}>
                {code}
              </Link>
            ) : (
              // Танихгүй кодын угтвар дээр эвдэрсэн холбоос үүсгэхгүй
              <span className="pending_order_code">{code || "-"}</span>
            )}
            <div className="pending_order_detail">
              <span className="pending_order_author">{email ?? "-"}</span>
              {note ? `: ${note}` : ""}
            </div>
          </div>
        </div>
      );
    },
  },
  {
    key: "date",
    width: 110,
    align: "right",
    render: (text, { date }) =>
      date ? (
        <Tooltip title={moment(date).format("YYYY/MM/DD HH:mm")}>
          <div className="pending_date">{moment(date).format("MM/DD HH:mm")}</div>
        </Tooltip>
      ) : (
        <div className="pending_date">-</div>
      ),
  },
];

const PendingOrders = ({ ordersWithNote, loading }) => (
  <div className="db_item_container order_notes_container">
    <div className="db_item_container_header">
      <h3>Тэмдэглэлтэй захиалга</h3>
    </div>
    <div className="db_item_container_body order_notes_body">
      {loading ? (
        <Skeleton active paragraph={{ rows: 6 }} />
      ) : (
        <Table
          showHeader={false}
          columns={columns}
          dataSource={ordersWithNote}
          // Огноо давхцаж болзошгүй тул тогтвортой `_id`-г түлхүүр болгоно
          rowKey={({ _id, code, date }) => _id ?? `${code}-${date}`}
          pagination={false}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Тэмдэглэлтэй захиалга байхгүй"
              />
            ),
          }}
        />
      )}
    </div>
  </div>
);

export default PendingOrders;
